<template>

    <Chart :type="type" :chartdata="chart" :options="options"  ></Chart>

    
</template>
<script>
import db from '@/components/firebase.init';
import Chart from '@/components/charts/Charts';
export default {
    data(){
        return{
            chartArray: [0,0,0,0,0,0,0,0,0,0,0,0],
            type: 'line-graph',
            loaded: false,
            chart: {},                       
            options: { 
                         tooltips: {
    callbacks: {
      label: function(tooltipItem, data) {
        var dataset = data.datasets[tooltipItem.datasetIndex];
        var meta = dataset._meta[Object.keys(dataset._meta)[0]];
        var total = meta.total;
        var currentValue = dataset.data[tooltipItem.index];
        var percentage = parseFloat((currentValue/total*100).toFixed(1));
        return currentValue + ' (' + percentage + '%)';
      },
      title: function(tooltipItem, data) {
        return data.labels[tooltipItem[0].index];
      }
    }
  },
                hover: {
                    animationDuration: '1',
                },               
                animation: {
                    easing: 'easeOutCubic',
                    numSteps: '90',
                    animateScale: false,

                },
                //  progpagate:true,
                legend: {
                    display: true,
                    labels: {
                    fontColor: 'white',
                    position: 'bottom',
                    }
                },                
                maintainAspectRatio: false,
                responsive: true,
                scales: {
                    yAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '1',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }],
                    xAxes: [{
                        display: true,
                            gridLines: {
                                display: true,
                                color: 'rgb(255, 255, 255, .3)',
                                borderDash: [1],
                                lineWidth: '1',
                                zeroLineWidth: '5',
                                zeroLineColor: 'rgb(255, 255, 255, .3)',
                                },
                        ticks: {
                            beginAtZero: true,
                            fontColor: 'white',
                        }
            
                    }]
                }
            },
            
        }
    },
    methods:{
        getChartData(){
            var docRef = db.collection("overallAnalytics").doc("widgetOne").collection("listing").doc("2019");
            docRef.get()
            .then(doc =>{
                const data = doc.data();
                if(data.JAN != null){
                    this.chartArray[0] = data.JAN;
                }
                if(data.FEB != null){
                    this.chartArray[1] = data.FEB;
                }
                if(data.MAR != null){
                    this.chartArray[2] = data.MAR;
                }
                if(data.APR != null){
                    this.chartArray[3] = data.APR;
                }
                if(data.MAY != null){
                    this.chartArray[4] = data.MAY;
                }
                if(data.JUN != null){
                    this.chartArray[5] = data.JUN;
                }
                if(data.JUL != null){
                    this.chartArray[6] = data.JUL;
                }
                if(data.AUG != null){
                    this.chartArray[7] = data.AUG;
                }
                if(data.SEP != null){
                    this.chartArray[8] = data.SEP;
                }
                if(data.OCT != null){
                    this.chartArray[9] = data.OCT;
                }
                if(data.NOV != null){
                    this.chartArray[10] = data.NOV;
                }
                if(data.DEC != null){
                    this.chartArray[11] = data.DEC;
                }
                this.loadChart();
            })
            .catch(e =>{
                alert(e)
            })
        },
        
        loadChart(){
            this.chart = {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June','July','Aug','Sept','Oct','Nov','Dec'],
                maxHeight : [
                                1
                            ],
                datasets: [
                    
                    // {fill: 'true'},
                    
                     
                        {
                            label: '2019',
                            data: this.chartArray,
                            backgroundColor: 'rgb(219, 46, 46,.7)',
                            fill : true,
                            pointBackgroundColor: [
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                            ],
                            borderColor: 'white',
                            pointBorderColor: [
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                                'red',
                                'blue',
                                'yellow',
                                'purple',
                                'pink',
                                'teal',
                            ],
                            pointRadius: '5',
                            pointHitRadius: '6',
                            // pointBackgroundColor: 'rand',
                            borderWidth: '2',
                            pointBorderWidth: '3',
                            
                            
                    }
                ],
                }
                this.loaded = true;
        }
    },
    components:{
        Chart
    },
    beforeMount(){
        this.getChartData();  
    },
    
}
</script>

